//import { useSelector, useDispatch } from 'react-redux';

/**
 * Crée un Work + Agent + Contribution + Expression + Manifestation
 * selon le modèle RDA-FR (langue sur Expression).
 *
 * @param {string} token JWT (Authorization)
 * @param {Object} data
 * @param {string} data.name                 Nom de l'utilisateur
 * @param {string} data.email               Email de l'utilisateur
 * @param {string} data.role                Role de l'utilisateur
 * @param {string} data.tel                 Téléphone de l'utilisateur
 * @param {string} data.code_etablissement  Code de l'établissement
 * @param {string} data.Password            Mot de passe de l'utilisateur
 * @param {string} data.PasswordHash        Mot de passe de l'utilisateur hashé (ne pas fournir)
 * gorm.Model
  Name              string `json:"name"`
  Email             string `json:"email" gorm:"index:uniq_user,unique;not null"`
  Password          string `json:"password"`
  PasswordHash      string `json:"password_hash"`
  Tel               string `json:"tel"`
  Role              string `json:"role"` // Admin, Bibliothécaire, Enseignant, Etudiant
  CodeEtablissement string `json:"code_etablissement"`
 */
async function createUser(API_BASE, token, data) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`,
  };

  const workRes = await fetch(`${API_BASE}/users`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });

  if (!workRes.ok) {
    throw new Error("Erreur création User: " + (await workRes.text()));
  }
  const work = await workRes.json();
  //console.log("User:", work);



  // On renvoie tout l'ensemble
  return {
    work,
  };
}
export default createUser;